import { useState } from 'react';
import React, { useEffect } from 'react';

const CheckboxControl = ({
    id,
    field,
    fieldName,
    value,
    onChange,
    onBlur,
    className,
    disabled,
    sequence,
    loading,
    props,
    'aria-invalid': ariaInvalid,
    'aria-describedby': ariaDescribedBy,
}) => {

    let inputId = id ?? ("field_cbx_" + field?.FieldName ?? fieldName + "_" + sequence ?? 1);
    const isChecked = value !== undefined && value !== null ? value == '1' || value === true || value.toString().toLowerCase() === 'true' || value.toString().toLowerCase() === 'yes' || value.toString().toLowerCase() === 'y' : false;
    return <div className={`cbx_control ${className ?? ''}`}>
        <div>
            <input
                id={inputId}
                key={inputId}
                type="checkbox"
                onBlur={(context) => onBlur ? onBlur(context, field) : null}
                checked={isChecked}
                disabled={disabled}
                onChange={(context) => {
                    if (onChange) {
                        onChange({ ...context, value: context.target.checked, target: { ...context.target, value: context.target.checked } }, field)
                    }
                }}
                aria-invalid={ariaInvalid}
                aria-describedby={ariaDescribedBy}
                {...props} />
        </div>
        {field?.DisplayName && (
            <label htmlFor={inputId}>
                {field.DisplayName}
                {field.IsRequired ? " *" : ""}
            </label>
        )}
    </div>
}

export default CheckboxControl;